{
  "main": {
    "zh-Hant": {
      "identity": {
        "version": {
          "_cldrVersion": "36"
        },
        "language": "zh-Hant"
      },
      "numbers": {
        "defaultNumberingSystem": "latn",
        "otherNumberingSystems": {
          "native": "hanidec",
          "traditional": "hans",
          "finance": "hansfin"
        },
        "minimumGroupingDigits": "1",
        "symbols-numberSystem-hanidec": {
          "decimal": ".",
          "group": ",",
          "list": ";",
          "percentSign": "%",
          "plusSign": "+",
          "minusSign": "-",
          "exponential": "E",
          "superscriptingExponent": "×",
          "perMille": "‰",
          "infinity": "∞",
          "nan": "NaN",
          "timeSeparator": ":"
        },
        "symbols-numberSystem-latn": {
          "decimal": ".",
          "group": ",",
          "list": ";",
          "percentSign": "%",
          "plusSign": "+",
          "minusSign": "-",
          "exponential": "E",
          "superscriptingExponent": "×",
          "perMille": "‰",
          "infinity": "∞",
          "nan": "NaN",
          "timeSeparator": ":"
        },
        "decimalFormats-numberSystem-hanidec": {
          "standard": "#,##0.###",
          "long": {
            "decimalFormat": {
              "1000-count-other": "0",
              "10000-count-other": "0萬",
              "100000-count-other": "00萬",
              "1000000-count-other": "000萬",
              "10000000-count-other": "0000萬",
              "100000000-count-other": "0億",
              "1000000000-count-other": "00億",
              "10000000000-count-other": "000億",
              "100000000000-count-other": "0000億",
              "1000000000000-count-other": "0萬億",
              "10000000000000-count-other": "00萬億",
              "100000000000000-count-other": "000萬億"
            }
          },
          "short": {
            "decimalFormat": {
              "1000-count-other": "0",
              "10000-count-other": "0萬",
              "100000-count-other": "00萬",
              "1000000-count-other": "000萬",
              "10000000-count-other": "0000萬",
              "100000000-count-other": "0億",
              "1000000000-count-other": "00億",
              "10000000000-count-other": "000億",
              "100000000000-count-other": "0000億",
              "1000000000000-count-other": "0萬億",
              "10000000000000-count-other": "00萬億",
              "100000000000000-count-other": "000萬億"
            }
          }
        },
        "decimalFormats-numberSystem-latn": {
          "standard": "#,##0.###",
          "long": {
            "decimalFormat": {
              "1000-count-other": "0",
              "10000-count-other": "0萬",
              "100000-count-other": "00萬",
              "1000000-count-other": "000萬",
              "10000000-count-other": "0000萬",
              "100000000-count-other": "0億",
              "1000000000-count-other": "00億",
              "10000000000-count-other": "000億",
              "100000000000-count-other": "0000億",
              "1000000000000-count-other": "0萬億",
              "10000000000000-count-other": "00萬億",
              "100000000000000-count-other": "000萬億"
            }
          },
          "short": {
            "decimalFormat": {
              "1000-count-other": "0",
              "10000-count-other": "0萬",
              "100000-count-other": "00萬",
              "1000000-count-other": "000萬",
              "10000000-count-other": "0000萬",
              "100000000-count-other": "0億",
              "1000000000-count-other": "00億",
              "10000000000-count-other": "000億",
              "100000000000-count-other": "0000億",
              "1000000000000-count-other": "0萬億",
              "10000000000000-count-other": "00萬億",
              "100000000000000-count-other": "000萬億"
            }
          }
        },
        "scientificFormats-numberSystem-hanidec": {
          "standard": "#E0"
        },
        "scientificFormats-numberSystem-latn": {
          "standard": "#E0"
        },
        "percentFormats-numberSystem-hanidec": {
          "standard": "#,##0%"
        },
        "percentFormats-numberSystem-latn": {
          "standard": "#,##0%"
        },
        "currencyFormats-numberSystem-hanidec": {
          "currencySpacing": {
            "beforeCurrency": {
              "currencyMatch": "[:^S:]",
              "surroundingMatch": "[:digit:]",
              "insertBetween": ""
            },
            "afterCurrency": {
              "currencyMatch": "[:^S:]",
              "surroundingMatch": "[:digit:]",
              "insertBetween": ""
            }
          },
          "standard": "¤#,##0.00",
          "accounting": "¤#,##0.00;(¤#,##0.00)",
          "short": {
            "standard": {
              "1000-count-other": "0",
              "10000-count-other": "¤0萬",
              "100000-count-other": "¤00萬",
              "1000000-count-other": "¤000萬",
              "10000000-count-other": "¤0000萬",
              "100000000-count-other": "¤0億",
              "1000000000-count-other": "¤00億",
              "10000000000-count-other": "¤000億",
              "100000000000-count-other": "¤0000億",
              "1000000000000-count-other": "¤0萬億",
              "10000000000000-count-other": "¤00萬億",
              "100000000000000-count-other": "¤000萬億"
            }
          },
          "unitPattern-count-other": "{0}{1}"
        },
        "currencyFormats-numberSystem-latn": {
          "currencySpacing": {
            "beforeCurrency": {
              "currencyMatch": "[:^S:]",
              "surroundingMatch": "[:digit:]",
              "insertBetween": ""
            },
            "afterCurrency": {
              "currencyMatch": "[:^S:]",
              "surroundingMatch": "[:digit:]",
              "insertBetween": ""
            }
          },
          "standard": "¤#,##0.00",
          "accounting": "¤#,##0.00;(¤#,##0.00)",
          "short": {
            "standard": {
              "1000-count-other": "0",
              "10000-count-other": "¤0萬",
              "100000-count-other": "¤00萬",
              "1000000-count-other": "¤000萬",
              "10000000-count-other": "¤0000萬",
              "100000000-count-other": "¤0億",
              "1000000000-count-other": "¤00億",
              "10000000000-count-other": "¤000億",
              "100000000000-count-other": "¤0000億",
              "1000000000000-count-other": "¤0萬億",
              "10000000000000-count-other": "¤00萬億",
              "100000000000000-count-other": "¤000萬億"
            }
          },
          "unitPattern-count-other": "{0}{1}"
        },
        "miscPatterns-numberSystem-hanidec": {
          "approximately": "~{0}",
          "atLeast": "{0}+",
          "atMost": "≤{0}",
          "range": "{0}-{1}"
        },
        "miscPatterns-numberSystem-latn": {
          "approximately": "~{0}",
          "atLeast": "{0}+",
          "atMost": "≤{0}",
          "range": "{0}-{1}"
        },
        "minimalPairs": {
          "pluralMinimalPairs-count-other": "{0}天",
          "other": "在第{0}個路口右轉。"
        }
      }
    }
  }
}
